/**
 * Copyright (C) Mairistem
 *
 * Unauthorized copying of this file, via any medium is strictly prohibited.
 *
 * Proprietary and confidential
 */

import React from 'react';

import { Loader } from '@mairistem/composants';

import EnteteApercu, { HAUTEUR_ENTETE_APERCU } from './EnteteApercu';

interface ApercuChargementProps {
  titre?: string;
}

/**
 * Panneau d'attente, le temps de télécharger et décoder un document.
 *
 * Il tient la place des panneaux de format pendant le chargement. Sans lui,
 * l'aperçu retombait sur le canevas — dont le bandeau porte les contrôles de
 * zoom, de déplacement et de pagination : passer d'un RTF à un Word les faisait
 * apparaître puis disparaître, alors qu'aucun des deux documents ne s'affiche
 * dans un canevas.
 */
const ApercuChargement = (props: ApercuChargementProps) => {
  const { titre } = props;

  return (
    <>
      <EnteteApercu titre={titre} />
      <div
        data-testid="apercu-chargement"
        style={{
          height: `calc(100% - ${HAUTEUR_ENTETE_APERCU}px)`,
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          border: '1px solid #dee2e6',
          borderTop: 'none',
          backgroundColor: '#f0f0f0',
        }}
      >
        <Loader active inline="centered" content="Chargement du document..." />
      </div>
    </>
  );
};

export default ApercuChargement;
